import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wineImage',
  pure: true
})
export class WineImagePipe implements PipeTransform {
  transform(value: any[], userWineId: string): unknown {
    let currentDetails;
    if (value?.length) {
      currentDetails = value.reverse().find((item: any) => userWineId === item.wineId);
    }
    return currentDetails?.images ? currentDetails.images : [];
  }
}
